export default function About() {
  return (
    <div
      id="about"
      className="bg-whitish py-16 px-12 dark:bg-greenish min-h-screen flex items-center justify-center flex-col"
    >
      <h3 className="mb-10 text-center overline text-greenish text-4xl font-bold dark:text-beige">
        About Me
      </h3>
      <div className="flex lg:flex-row flex-col text-justify  justify-center items-center">
        <div className="px-6 md:text-2xl sm:text-xl text-lg my-1 md:font-normal font-normal text-night dark:text-whitish md:w-3/4 flex flex-col">
          <p className="pb-3">
            As a front-end developer and graphic designer with a background in
            nursing, I bring a unique set of skills to the tech industry. My
            years as a nurse have honed my communication and problem-solving
            abilities, as well as my ability to work effectively in a team.
            These skills, combined with my technical proficiency in technologies
            such as ReactJS, Javascript, Tailwind CSS, Redux Toolkit, HTML, and
            CSS, make me a valuable asset to any development team.
          </p>
          <p>
            After graduating from the Lebanese University with a degree in
            Nursing, I took a year to reassess my career goals and found my
            passion in coding and technology. I enrolled in{' '}
            <a
              href="https://www.re-coded.com/"
              className="inline underline dark:text-beige text-greenish"
              rel="noreferrer"
              target="_blank"
            >
              Re:Coded
            </a>
            's Front-End bootcamp and quickly transformed from a complete
            beginner to a confident front-end developer. In addition to my
            technical skills, I bring a creative touch to my work through my
            graphic design experience, using tools like Adobe Illustrator, Adobe
            Photoshop, Canva, and Figma to create visually appealing designs.
            You can read about my success story at Re:Coded{' '}
            <a
              className="inline underline dark:text-beige text-greenish"
              href="https://www.re-coded.com/blog/sarah-success-story"
              rel="noreferrer"
              target="_blank"
            >
              here
            </a>
            .
          </p>
          <p className="pt-3">
            I am passionate about using my skills and experience to create
            user-friendly and visually pleasing websites that meet the needs of
            my clients. I am constantly seeking out opportunities to expand my
            knowledge and explore new technologies. In my free time, I enjoy
            reading, photography, hiking, and embroidering. 
          </p>
        </div>
      </div>
    </div>
  );
}
